// ============================================================
// Mesure d'audience first-party — côté React
// ============================================================
// Envoie des beacons vers POST /api/track (voir TrackController backend).
// Sans cookie, sans donnée personnelle, silencieux : un échec de mesure ne
// doit JAMAIS impacter le visiteur.

import { mesureAutorisee } from './consentement';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3333/api';

const send = (payload) => {
  // Le bandeau propose de refuser la mesure : jusqu'ici ce refus n'était relu
  // par personne et le beacon partait quand même.
  if (!mesureAutorisee()) return;
  try {
    fetch(`${API_URL}/track`, {
      method: 'POST',
      keepalive: true,
      credentials: 'omit',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    }).catch(() => {});
  } catch {
    /* jamais bloquant */
  }
};

/** Transforme un pathname en slug borné accepté par le backend. */
export const pageSlug = (pathname) => {
  const slug = (pathname === '/' ? 'home' : pathname)
    .toLowerCase()
    .replace(/^\/+|\/+$/g, '')
    .replace(/\//g, ':')
    .replace(/[^a-z0-9:_-]/g, '-')
    .slice(0, 64);
  return /^[a-z0-9]/.test(slug) ? slug : null;
};

/**
 * La langue RÉELLEMENT lue, et non celle du navigateur.
 *
 * `navigator.language` répond « fr-BE » pour un visiteur dont le téléphone est
 * en français mais qui lit le site en allemand — et l'inverse. Le tableau
 * « Langues (30 j) » comptait donc la langue du téléphone : un lecteur
 * allemand apparaissait en FR. `documentElement.lang` est posé par le
 * sélecteur de langue : c'est la seule valeur qui dit ce qui a été lu.
 */
const langueLue = () => {
  const duSite = (document.documentElement.getAttribute('lang') || '').slice(0, 5);
  return duSite || (navigator.language || '').slice(0, 5) || undefined;
};

/** Vue d'une page publique — anonyme, avec provenance (host uniquement) et langue. */
export const trackPv = (page) =>
  send({
    k: 'pv',
    p: page,
    r: document.referrer || undefined,
    l: langueLue(),
  });

/**
 * Clic sur un CTA (id format 'page:emplacement', ex. 'shop:add-to-cart').
 *
 * Le backend refuse tout identifiant hors /^[a-z0-9][a-z0-9:_-]{0,63}$/ et
 * repond 204 quand meme : un id mal forme serait perdu SANS AUCUNE TRACE. On
 * normalise donc a l'emission, en reutilisant pageSlug. Les '/' deviennent des
 * '-' au prealable : un identifiant de CTA n'est pas un chemin, ':' y separe
 * la page de l'emplacement.
 */
export const trackCta = (id) => {
  const p = pageSlug(String(id).replace(/\//g, '-'));
  // La langue voyage aussi avec le clic : sans elle, aucune segmentation
  // linguistique des CTA n'était possible.
  if (p) send({ k: 'cta', p, l: langueLue() });
};
